// Copyright (c) 2021 Deere & Company

import actions from '../actions-list';

export const updateRequestedRate = (index, rate, requestId) => ({
    index,
    rate,
    requestId,
    type: actions.UPDATE_MASS_LABOR_RATE_REQUESTED_RATE
});

export const updateComments = (index, comment) => ({
    comment,
    index,
    type: actions.UPDATE_MASS_LABOR_RATE_COMMENT
});

export const updateEffectiveDate = effectiveDate => ({
    effectiveDate,
    type: actions.UPDATE_MASS_LABOR_RATE_EFFECTIVE_DATE
});

export const updateAverageTechPayRate = rate => ({
    rate,
    type: actions.UPDATE_MASS_LABOR_RATE_AVERAGE_TECH_PAY_RATE
});

export const addFile = file => ({
    file,
    type: actions.UPDATE_MASS_LABOR_RATE_FILE
});

export const resetDealerDetails = () => ({
    type: actions.RESET_CLAIM_DEALER_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/labor-rate.js